import React from "react";

import Divider from "components/Divider";

import classes from "./styles.module.scss";

const NewBalance = ({ currentBalance = 0, toPurchase = 0 }) => {
    const newBalance = currentBalance + toPurchase;

    return (
        <div className={classes.newBalanceContainer}>
            <div className={classes.detailsContainer}>
                <div className={classes.amountRow}>
                    <span className={classes.leftSpan}>Current credit balance</span>
                    <span>{currentBalance}</span>
                </div>
                <div className={classes.amountRow}>
                    <span>New credits</span>
                    <span>{toPurchase}</span>
                </div>
            </div>
            <Divider />
            <div>
                <div className={classes.amountRow}>
                    <span className={classes.leftSpan}>Balance after purchase:</span>
                    <span>{newBalance}</span>
                </div>
            </div>
        </div>
    );
};

export default NewBalance;
